import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonContractCommitmentCriteria } from '@core/models/contract-commitment-criteria.model';
import { JsonContractCommitmentImmutable } from '@core/models/contract-commitment.model';
import { BaseService } from '@core/services/base/base.service';
import { ErrorHandlerService, HttpError } from '@core/services/error-handler.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommitmentService extends BaseService {
  protected contractCommitmentRoute = environment.contract_microservice_api_base_url + '/contract-commitment/by-contract/';
  protected computeByRoute = environment.contract_microservice_api_base_url + '/contract-commitment-criteria/calcul-by-payload';

  constructor(private httpService: HttpClient, private errorHandlerService: ErrorHandlerService) {
    super();
  }

  public getComputeByPayload(commitments, commitmentsCriterias, year = null) {
    const filter = {};
    const httpErrors: HttpError[] = [
      {
        statusCode: 404,
        message: 'Impossible de mettre à jour la liste des commitments. Veuillez essayer plus tard.',
      },
      {
        statusCode: 500,
        message: 'Une erreur est survenue. Veuillez essayer plus tard.',
      },
    ];

    const url = this.computeByRoute + this.getParamsFromFilter(filter);

    return new Observable(observer => {
      this.httpService.post(url, { commitments: commitments, criterias: commitmentsCriterias, year: year }).subscribe(
        (response: any) => observer.next(response),
        error => {
          this.errorHandlerService.showErrorMessage(httpErrors, error.status);
          observer.error(error);
        }
      );
    });
  }

  public updateCommitments(
    contractId: string,
    year: string,
    commitments: JsonContractCommitmentImmutable[],
    commitmentCriterias: JsonContractCommitmentCriteria[]
  ): Observable<any> {
    const filter = {};
    const httpErrors: HttpError[] = [
      {
        statusCode: 404,
        message: 'Impossible de mettre à jour la liste des commitments. Veuillez essayer plus tard.',
      },
      {
        statusCode: 500,
        message: 'Une erreur est survenue. Veuillez essayer plus tard.',
      },
    ];

    const url = this.contractCommitmentRoute + year + '/' + contractId + this.getParamsFromFilter(filter);

    return new Observable(observer => {
      this.httpService.put(url, { commitments: commitments, criterias: commitmentCriterias }).subscribe(
        (response: any) => {
          observer.next(response);
          observer.complete(); // ✅ très important pour le forkJoin !
        },
        error => {
          this.errorHandlerService.showErrorMessage(httpErrors, error.status);
          observer.error(error);
          observer.complete(); // on peut ou non compléter après une erreur
        }
      );
    });
  }
}
